module.exports = __webpack_public_path__ + "img/体验版.5ed3c273.png";